import { defineComponent as _defineComponent } from 'vue'
import { useLocation, useMap } from "@/services";
import { onMounted, ref } from "vue";

import { useGoogleLoader } from "@/util/google-maps-loader";


export default /*#__PURE__*/_defineComponent({
  __name: 'StreetView',
  setup(__props) {

const mapPanorama = ref<HTMLDivElement | null>(null);
const hasError = ref<boolean>(false);

onMounted(async () => {
  const locationStore = useLocation();
  const mapStore = useMap();
  const coords =
    locationStore.location && locationStore.coordinates
      ? locationStore.coordinates
      : mapStore.mapPosition.center;

  hasError.value = false;
  try {
    await loadPanorama(coords[1], coords[0]);
  } catch (e) {
    hasError.value = true;
    throw e;
  }
});

async function loadPanorama(lat: number, lng: number) {
  const loader = useGoogleLoader();
  if (loader.value && mapPanorama.value) {
    const { StreetViewPanorama } = await loader.value.importLibrary(
      "streetView"
    );
    return new StreetViewPanorama(mapPanorama.value, {
      position: { lat, lng },
      pov: {
        heading: 34,
        pitch: 10,
      },
    });
  }
}

return { __sfc: true,mapPanorama, hasError, loadPanorama }
}

})